import React from "react";

function Fieldset(props) {
  const classes = props.custom ? props.classes : `flex flex-col border-b-1 border-light-grey ${props.classes ? props.classes : ""}`;
  return <fieldset className={classes}>{props.children}</fieldset>;
}

export default Fieldset;
